import React from 'react';
import PurchaseOrderViewInfoEntry from './PurchaseOrderViewInfoEntry';

import { CustomizedTypography } from '@components/Customized';
import { formatDate } from '@utils/formatter';

import useStyles from './useStyles';
import { CapaQuotationRfqPurchaseOrder } from '@generated/graphql';

interface Props {
  currentItem?: CapaQuotationRfqPurchaseOrder;
}

const PurchaseOrderDeliveryInfo = ({ currentItem }: Props) => {
  const classes = useStyles();

  const shipDate = currentItem?.shipDate ?? '';

  const shipAddress = currentItem?.shipAddress ?? '';

  const shipDetailAddress = currentItem?.shipDetailAddress ?? '';

  return (
    <div className={classes.wrapper + ' gutter'}>
      <CustomizedTypography variant="h4" fontWeight="500" gutterBottoms={8}>
        납품 정보
      </CustomizedTypography>

      <PurchaseOrderViewInfoEntry
        label="납품일자"
        data={formatDate(shipDate, 'YYYY년 MM월 DD일')}
      />
      <PurchaseOrderViewInfoEntry
        label="납품주소"
        data={`${shipAddress}${
          shipDetailAddress ? `, ${shipDetailAddress}` : ''
        }`}
      />
    </div>
  );
};

export default PurchaseOrderDeliveryInfo;
